export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
